<template>
  <div>
    <v-btn
      class="fixed-r-btn"
      fab
      medium
      icon
      color="primary"
      :disabled="filter_survey == ''"
      @click="getReportData"
    >
      <v-icon>cached</v-icon>
    </v-btn>
    <v-card>
      <v-card-title primary-title>
        Reportes Gráficos Encuestas Realizadas
      </v-card-title>
      <v-card-title>
        <v-layout d-flex row wrap fill-height align-center>
          <v-flex mr-3 xs12 md3>
            <v-select
              :items="surveys"
              v-model="filter_survey"
              label="Encuesta"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-flex>
          <v-flex
            xs12
            md3
            ml-3
            class="text-xs-center"
          >
            <v-progress-circular
              :rotate="360"
              :size="100"
              :width="15"
              :value="(totalSurveys * 100) / totalSurveys"
              color="primary"
            >
              Total
              <br>
              {{ totalSurveys }}
            </v-progress-circular>
          </v-flex>
          <v-flex
            xs12
            md3
            v-for="(data, index) in qtyData"
            :key="index"
            class="text-xs-center"
          >
            <v-progress-circular
              :rotate="360"
              :size="100"
              :width="15"
              :value="data.cant * 100 / totalSurveys"
              :color="data.estado == 0 ? 'red' : 'teal'"
            >
              {{ data.estado == 0 ? 'Pend' : 'Compl' }}
              <br>
              {{ data.cant }}
            </v-progress-circular>
          </v-flex>
        </v-layout>
      </v-card-title>
      <br>
      <br>
      <v-layout d-flex row wrap fill-height>
          <v-flex
            mr-3
            xs12
            class="elevation-10"
          >
            <v-expansion-panel class="elevation-5">
              <v-expansion-panel-content
              v-for="(data, index) in textData"
              :key="index"
              >
                <template v-slot:header>
                  <div class="title">{{ data.question }}</div>
                </template>
                <v-card class="elevation-10">
                  <v-card-text
                    v-for="(answ, i) in data.answ"
                    :key="i"
                  >
                    <v-icon small color="teal darken-2">email</v-icon>
                    {{answ}}
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
      </v-layout>
      <br />
      <br />
      <v-layout d-flex row wrap fill-height>
          <v-flex
            mr-3
            xs12
            md6
            v-for="(data, index) in charData"
            :key="index"
          >
            <v-card class="elevation-3">
              <v-card-text primary-title>
                {{ data.question }}
              </v-card-text>
              <div id="chart">
                <apexchart type="line" width="80%" height="250" :options="data.chartOptions" :series="data.series"></apexchart>
              </div>
            </v-card>
          </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'survey-chart-report-view',
    data() {
      return {
        surveys: [],
        filter_survey: '',
        charData: [],
        textData: [],
        qtyData: [],
        totalSurveys: 0,
      }
    },
    watch: {
      filter_survey(newValue, oldValue) {
        if (newValue !== '') {
          this.getReportData()
        }
      }
    },
    created () {
      this.init();
    },
    methods: {
      init() {
        axios.get('/api/surveys')
          .then(resp => {
            if (resp.status === 200) {
              this.surveys = resp.data.surveys
            }
          })
      },
      getReportData() {
        const survey_id = this.filter_survey
        axios.get(`/api/surveys/report/${survey_id}/chart`)
          .then(response => {
            if (response.status === 200) {
              const {
                selecttionData,
                textData,
                qtyData,
              } = response.data
              this.charData = []
              this.textData = []
              this.processSelectionQuestions(selecttionData)
              this.processTextQuestions(textData)
              this.processQtyData(qtyData)
            }
          })
      },
      processSelectionQuestions(data) {
        const groupedData = this.groupBy(data, d => d.pregunta)
        let charData = []
        groupedData.forEach((answers, question) => {
          const serie = answers.map(_ => _.cant)
          const labels = answers.map(_ => _.opcion)
          const rowChartData = {
            question,
            series: [
              {
                name: '',
                type: 'column',
                data: [...serie],
              },
              {
                name: '',
                type: 'line',
                data: [...serie],
              },
            ],
            chartOptions: {
              chart: {
                height: 350,
                type: 'line',
              },
              stroke: {
                width: [0, 2]
              },
              title: {
                text: ''
              },
              dataLabels: {
                enabled: true,
                enabledOnSeries: [1]
              },
              labels: [...labels],
              yaxis: [{
                title: {
                  text: '',
                },
              }, {
                opposite: true,
              }]
            }
          }
          charData.push(rowChartData)
        })
        this.charData = [...charData]
      },
      processTextQuestions(data) {
        const groupedData = this.groupBy(data, d => d.pregunta)
        let textData = []
        groupedData.forEach((answers, question) => {
          const answ = answers.map(_ => _.respuesta)
          const rowData = {
            question,
            answ,
          }
          textData.push(rowData)
        })
        this.textData = [...textData]
      },
      processQtyData(data) {
        this.qtyData = data
        let total = 0;
        data.forEach((a) => total += a.cant)
        this.totalSurveys = total
      },
      groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
      }
    },
  }
</script>

<style lang="scss" scoped>
.fixed-r-btn {
  position: fixed;
  right: 30px;
  z-index: 99;
}

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/surveys/chart_report.vue